// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
export default createVuetify({
    defaults: {
        global: {
            font: {
                family: '"Microsoft YaHei","Noto Sans CJK SC", "Source Han Sans CN",  sans-serif',
            },
        },
    },
    // 开关灯模式主题
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                dark: false,
                colors: {
                    primary: '#1976D2',
                    background: '#FFFFFF'
                }
            },
            dark: {
                dark: true,
                colors: {
                    primary: '#2196F3',
                    background: '#121212'
                }
            }
        }
    }
});
